// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * OPC UA message security mode.
 */
export enum MessageSecurityMode {
  None_ = 0,
  Sign = 1,
  SignAndEncrypt = 2,
}
